module.exports = __webpack_public_path__ + "img/imgTemaActual.3db8317d.jpg";